<script setup lang="ts">
import { defineProps, ref } from 'vue';
import { UserResponseDto } from '@clearbanc/baus-sdk';
import { useUserInviteManagement } from '@/composables/user-invite-management';
import { RESEND_AUTH0_INVITE_COOLDOWN_MINUTES } from '@/data/user-invite';

import Button from 'primevue/button';

const props = defineProps<{
  user: UserResponseDto;
}>();

const { hasPendingInvite, canResendInvite, resendInvite, loadingUserInvite } =
  useUserInviteManagement(ref(props.user.id));
</script>

<template>
  <div
    v-if="hasPendingInvite"
    v-tooltip.left="{
      value: `You will be able to resend the invite in ${`${RESEND_AUTH0_INVITE_COOLDOWN_MINUTES} minutes`}.`,
      disabled: canResendInvite,
    }"
    class="user-invite-actions-tooltip"
  >
    <Button
      :disabled="!canResendInvite"
      label="Resend Invite"
      @click="resendInvite()"
      :loading="loadingUserInvite"
      outlined
      class="p-button-outlined resend-invite-button"
    ></Button>
  </div>
</template>

<style lang="less" scoped>
.user-invite-actions-tooltip {
  display: inline-block;
}
.resend-invite-button {
  font-size: 0.75rem;
  padding: 0.2rem 0.5rem;
  white-space: nowrap;
}
</style>
